export class AtlasGrid {
    constructor(atlasWidth, atlasHeight, cellSize) {
        this.atlasWidth = atlasWidth;
        this.atlasHeight = atlasHeight;
        this.cellSize = cellSize;
        this.cols = Math.floor(this.atlasWidth / this.cellSize);
        this.rows = Math.floor(this.atlasHeight / this.cellSize);
        this.freeCells = this.totalCells = this.cols * this.rows;
        this.columnHeights = new Uint8Array(this.cols);
    }
    allocate(widthPx, heightPx) {
        if (widthPx <= 0 || heightPx <= 0)
            return null;
        const cs = this.cellSize;
        const cw = Math.ceil(widthPx / cs);
        const ch = Math.ceil(heightPx / cs);
        if (cw <= 0 || ch <= 0)
            return null;
        if (cw > this.cols || ch > this.rows)
            return null;
        const cols = this.cols;
        const rows = this.rows;
        const heights = this.columnHeights;
        let bestCol = -1;
        let bestHeight = Number.MAX_SAFE_INTEGER;
        outer: for (let c = 0; c <= cols - cw; c++) {
            let maxH = 0;
            for (let cc = c; cc < c + cw; cc++) {
                const hCol = heights[cc];
                if (hCol > maxH)
                    maxH = hCol;
                if (maxH + ch > rows) {
                    continue outer;
                }
            }
            if (maxH < bestHeight) {
                bestHeight = maxH;
                bestCol = c;
                if (bestHeight === 0)
                    break;
            }
        }
        if (bestCol < 0)
            return null;
        const x = bestCol * cs;
        const y = bestHeight * cs;
        const newH = bestHeight + ch;
        for (let cc = bestCol; cc < bestCol + cw; cc++) {
            const oldH = heights[cc];
            heights[cc] = newH;
            this.freeCells -= (newH - oldH);
        }
        const region = {
            x,
            y,
            w: cw * cs,
            h: ch * cs,
            _cx: cw,
            _cy: ch
        };
        return region;
    }
    reset() {
        if (this.freeCells === this.totalCells)
            return;
        this.columnHeights.fill(0);
        this.freeCells = this.totalCells;
    }
}
